"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.describeLineChanges = void 0;
/** What a line's quantity reads as when the line is not on that side at all. */
const ABSENT = 'none';
const quantityLabel = (quantity) => quantity === undefined ? ABSENT : String(quantity);
/**
 * A one-line, human-readable description of what a line replacement changed:
 * `"3: 12→4, 7: none→5, 9: 2→none"`, ordered by productId and listing only the
 * lines that actually moved (`"no line changes"` when none did).
 *
 * It exists because an `EDITED` marker on its own answers "something happened"
 * and nothing else — an auditor reading a store's week could not tell a
 * one-unit correction from opting out of the whole order.
 *
 * ABSENT IS NOT ZERO, and that is the reason this is a real function rather
 * than a template string: a stored zero reads as "sin pedido" — written by a
 * store whose floor (`minQuantityPerProduct`) is 0, by staff from the
 * backoffice, or inherited from history — while absent means the line is not
 * on the order at all. Collapsing the two would erase that distinction in the
 * only record there is.
 *
 * Ordered by productId because the input arrays arrive in whatever order the
 * client sent them, and a detail whose text depends on that cannot be compared
 * between two entries.
 */
const describeLineChanges = (previous, next) => {
    const previousByProduct = new Map(previous.map((line) => [line.productId, line.quantity]));
    const nextByProduct = new Map(next.map((line) => [line.productId, line.quantity]));
    const changed = [...new Set([...previousByProduct.keys(), ...nextByProduct.keys()])]
        .sort((left, right) => left - right)
        .filter((productId) => previousByProduct.get(productId) !== nextByProduct.get(productId))
        .map((productId) => `${productId}: ${quantityLabel(previousByProduct.get(productId))}→${quantityLabel(nextByProduct.get(productId))}`);
    return changed.length > 0 ? changed.join(', ') : 'no line changes';
};
exports.describeLineChanges = describeLineChanges;
//# sourceMappingURL=line-diff.js.map